import React, { useState, useMemo, useRef } from 'react'
import { message } from 'antd'
import { isPermissions, sampleHasAuth } from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src//utils/request'
import { ossImg } from 'meinian-package/src/utils/image'
import util from 'meinian-package/src/utils/util'
import { Ul, Li, Dropdown } from 'meinian-package/src/baseComponent'
import { SAMPLE_STATE } from 'common/config/sample.enum'
import SampleDetail from 'view/detail/sampleDetail'
import userInfo, { getTeamInfo } from 'meinian-package/src/common/userInfo'
import moreFolderModalFun from '../useFunModal/moveFolder'
import './sampleCard.less'
import { BatchItem } from '../batch'
import EditSample from '../editSample'
import SampleCardExamine from './sampleCardExamine'
import { getSampleStatusLabel } from './sampleCardExamine/common'
import { MoreBtn } from './action'

export default (props) => {
  const {
    isBatch,
    data,
    item: itemData,
    columnWidth,
    total,
    action,
  } = props

  const {
    state,
    mainImgUrl,
    id,
    name,
    sampleCode,
    stepId,
    stepStatus,
    process,
    processId,
    sampleClothingAuth,
    sampleFolderId,
  } = itemData || {}

  const [lastRouter] = useState(location.pathname + location.search)
  const teamInfo = getTeamInfo()
  const sampleFolderIdRef = useRef(sampleFolderId)
  const [visible, setVisible] = useState(false)
  const [detailVisible, setDetailVisible] = useState(false)

  const onDeleteSample = async () => {
    try {
      await request.get(`/zhikuan/mn/sample/delete-sample-info?sampleId=${id}`)
      message.success('删除成功')
      action.onDelete(id)
      props?.onResize?.()
      setVisible(false)
    } catch (err) {
      console.error(`/zhikuan/mn/sample/delete-sample-info?sampleId=${id}`, err)
    }
  }

  const color = (_state) => {
    if (_state === SAMPLE_STATE.UNMAKE_PATTERN || _state === SAMPLE_STATE.MAKING_PATTERN || _state === SAMPLE_STATE.MADE_PATTERN) {
      return '#FA8B16'
    }
    if (_state === SAMPLE_STATE.MAKING_SAMPLE || _state === SAMPLE_STATE.MADE_SAMPLE) {
      return 'var(--m-success-normal)'
    }
    if (_state === SAMPLE_STATE.PURCHASING || _state === SAMPLE_STATE.PURCHASED) {
      return '#E6405C'
    }
    if (_state === SAMPLE_STATE.IN_STORAGE) {
      return '#2D67B3'
    }
  }

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
    }
  }

  const sampleStateText = useMemo(() => {
    return getSampleStatusLabel({ process, processId, stepStatus, stepId, state })
  }, [state, data, process, stepId, processId])

  const onMove = async (_curData, _id) => {
    const result = await request.post('/zhikuan/mn/sample/folder/move-sample-clothing', { toFolderId: _id, sampleIdList: [id] })
    if (result) {
      message.success('移动成功')
      props?.init?.()
    }
  }

  return <div style={{ width: columnWidth, height: columnWidth + 52 }}>
    <div className="meinian-waterfall-card-sample">
      <div className="card-sample-cover-wrap">
        <span
          style={{ backgroundImage: `url(${ossImg(mainImgUrl, 600, 600)})` }}
          className="card-sample-cover-1"
        />
        {isBatch ? <div className="batch-mask">
          <BatchItem keyValue={id} className="batch-check" info={itemData} />
          {state ? <span className="batch-mask-state">{sampleStateText}</span> : null}
        </div> : <div
          className={`cover-wrap-mask  mn-sample-image-base-${id}`}
          onClick={() => {
            history.replaceState({}, '', `/meinian/detail/sample/image?sampleCode=${itemData.sampleCode}`)
            setDetailVisible(true)
          }}
        >
          <div className="wrap-mask-header">
            {state ? <span
              className="mask-header-state"
              style={{ backgroundColor: color(state) }}
            >{sampleStateText}</span>
              : null}
            <div className="meinian-space" />
            {isPermissions(sampleClothingAuth, ['operateAndUpdateSample', 'moveAndDeleteSample']) ? <Dropdown
              trigger="hover"
              placement="bottomRight"
              className="mn-ins-more-options"
              getPopupContainer={() => document.querySelector(`.mn-sample-image-base-${id}`) || document.body}
              overlay={<Ul style={{ width: 128 }}>
                {
                isPermissions(sampleClothingAuth, ['operateAndUpdateSample']) && <Li
                  className="mn-dropdown-icon-li"
                  onClick={(e) => {
                    util.track('mn_edit_sample', {
                      module1: '样衣详情页',
                      module2: '基本信息'
                    })
                    e.stopPropagation(); setVisible(true)
                  }}
                ><Icon type="m-bianji" />编辑</Li>
              }
                {
                isPermissions(sampleClothingAuth, ['moveAndDeleteSample']) && <>
                  <Li
                    className="mn-dropdown-icon-li"
                    onClick={(e) => {
                      e.stopPropagation()
                      moreFolderModalFun?.({
                        title: '移动样衣至',
                        type: 'sample',
                        createFolderAuth: sampleHasAuth('createAndUpdateFolder'),
                        option: {
                          id: sampleFolderIdRef.current
                        },
                        onOk: onMove
                      })
                    }}
                  ><Icon type="m-yidong" />移动</Li>
                  <div className="li-partition" />
                  <Li
                    className="mn-dropdown-icon-li delete"
                    onClick={(e) => {
                      e.stopPropagation()
                      ModalConfirm.show({
                        title: '确认删除该样衣？',
                        content: '删除后不可恢复',
                        onOk: onDeleteSample
                      })
                    }}
                  ><Icon type="m-shanchu" />删除</Li>
                </>
              }
              </Ul>}
            >
              <MoreBtn />
            </Dropdown> : null}
          </div>
          {
          processId > 0 && isPermissions(sampleClothingAuth, ['operateAndUpdateSample']) && <SampleCardExamine
            process={process}
            id={id}
            stepId={stepId}
            stepStatus={stepStatus}
            onClick={(newData) => {
              action.onUpdate({ stepStatus: newData.stepStatus, processId: newData.processId, stepId: newData.stepId, id })
            }}
          />
        }
        </div>}
      </div>
      {detailVisible ? <SampleDetail
        list={data}
        maxListLength={total || data.length}
        onChangeIndex={props.onChangeIndex}
        initWaterfall={props.initWaterfall}
        initSubColls={props.initSubColls}
        visible={detailVisible}
        onChange={_onChange}
        onDeleteItem={(_id) => {
          action.onDelete(_id)
          props.onResize()
        }}
        onVisibleChange={(_visible) => {
          history.replaceState({}, '', lastRouter)
          setDetailVisible(_visible)
        }}
      /> : null}
      {visible ? <EditSample
        visible={visible}
        isHome
        data={itemData}
        setVisible={setVisible}
        onChange={_onChange}
        accountInfo={userInfo}
        teamInfo={teamInfo}
      /> : null}
      <div className="card-sample-info">
        <div className="sample-info-title">{name}</div>
        <div className="sample-info-id">{sampleCode}</div>
      </div>
    </div>
  </div>
}
